/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Unknown_ErrorInputs */

const en_auth_unknown_error = /** @type {(inputs: Auth_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown error occurred`)
};

const es_auth_unknown_error = /** @type {(inputs: Auth_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un error desconocido`)
};

/**
* | output |
* | --- |
* | "Unknown error occurred" |
*
* @param {Auth_Unknown_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_unknown_error = /** @type {((inputs?: Auth_Unknown_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Unknown_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_unknown_error(inputs)
	return en_auth_unknown_error(inputs)
});